import {
    IProps,
    IRef,
} from './types';

import classNames from 'classnames';
import React, {
    forwardRef,
    useImperativeHandle,
    useState,
} from 'react';

import {
    ICreatePaymentDto,
} from 'entities/payments/requests/create-payment.dto';

import AmountCard from './AmountCard';
import ClientFieldsValuesInput, {
    useClientFieldsValuesInputRef,
} from './ClientFieldsValuesInput';
import DetailFieldsCard from './DetailFieldsCard';

import styles from './PaymentForm.module.scss';

const PaymentForm = forwardRef<IRef, IProps>((props, ref) => {
    const [isPending, setIsPending] = useState(false);

    const onSubmit = async () => {
        setIsPending(true);
        await props.onSubmit();
        setIsPending(false);
    };

    const clientFieldsValuesInputRef = useClientFieldsValuesInputRef();

    useImperativeHandle(ref, () => {
        return {
            getDto(): ICreatePaymentDto | null {
                return {
                    encodedAccountStatisticId: props.accountStatistic.encodedId,
                    attachmentId: null,
                    clientFieldsValues: clientFieldsValuesInputRef.current.getValue(),
                };
            },
            validate(): boolean {
                return ![
                    clientFieldsValuesInputRef.current.validate(),
                ].includes(false);
            },
            setError(error: string | null): void {
                clientFieldsValuesInputRef.current.setError(error);
            },
        };
    });

    return (
        <div className={classNames(styles.paymentForm, props.className)}>
            <AmountCard
                amountKopecks={props.accountStatistic.amountKopecks}
                currencySymbol={props.accountStatistic.paymentMethod.currencySymbol}
            />
            <DetailFieldsCard
                className={styles.detailFieldsCard}
                paymentPageType={props.accountStatistic.paymentMethod.paymentPageType}
                detailFieldsBlockHint={props.accountStatistic.paymentMethod.detailFieldsBlockHint}
                detailFields={props.accountStatistic.paymentMethod.detailFields}
                amountKopecks={props.accountStatistic.amountKopecks}
                payment={props.accountStatistic.payment}
                onPending={props.onPending}
            />
            {
                !!props.accountStatistic.paymentMethod.clientFields.length &&
                <ClientFieldsValuesInput
                    ref={clientFieldsValuesInputRef}
                    className={styles.clientFieldsValuesInput}
                    clientFieldsBlockHint={props.accountStatistic.paymentMethod.clientFieldsBlockHint}
                    clientFields={props.accountStatistic.paymentMethod.clientFields}
                    isDisabled={isPending}
                    onSubmit={onSubmit}
                />
            }
        </div>
    );
});

export default PaymentForm;
